var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.945,
    height: 27.945,
    viewBox: "0 0 27.945 27.945",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n      }\n\n      .cls-2 {\n\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reports",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "rgba(255, 255, 255, 0.40)",
    id: "news"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "cls-2",
    d: "M25.325,0H6.113a2.619,2.619,0,0,0-2.62,2.62V4.366H2.62A2.619,2.619,0,0,0,0,6.986V24.452a3.493,3.493,0,0,0,3.493,3.493H24.452a3.493,3.493,0,0,0,3.493-3.493V2.62A2.62,2.62,0,0,0,25.325,0ZM26.2,24.452A1.749,1.749,0,0,1,24.452,26.2H3.493a1.749,1.749,0,0,1-1.747-1.747V6.986a.874.874,0,0,1,.873-.873h.873V23.578a.873.873,0,1,0,1.747,0V2.62a.874.874,0,0,1,.873-.873H25.325a.874.874,0,0,1,.873.873Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-2",
    d: "M19.435,12.878h6.986a.437.437,0,0,0,0-.873H19.435a.437.437,0,0,0,0,.873Z",
    transform: "translate(-2.408 -1.521)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-2",
    d: "M19.435,9.878h6.986a.437.437,0,1,0,0-.873H19.435a.437.437,0,0,0,0,.873Z",
    transform: "translate(-2.408 -1.141)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-2",
    d: "M19.435,6.878h6.986a.437.437,0,1,0,0-.873H19.435a.437.437,0,0,0,0,.873Z",
    transform: "translate(-2.408 -0.761)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "cls-2",
    d: "M15.423,27H8.437a.437.437,0,0,0,0,.873h6.986a.437.437,0,0,0,0-.873Z",
    transform: "translate(-1.014 -3.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    className: "cls-2",
    d: "M15.423,24H8.437a.437.437,0,1,0,0,.873h6.986a.437.437,0,0,0,0-.873Z",
    transform: "translate(-1.014 -3.042)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    className: "cls-2",
    d: "M15.423,21H8.437a.437.437,0,1,0,0,.873h6.986a.437.437,0,0,0,0-.873Z",
    transform: "translate(-1.014 -2.662)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    className: "cls-2",
    d: "M26.423,27H19.437a.437.437,0,0,0,0,.873h6.986a.437.437,0,1,0,0-.873Z",
    transform: "translate(-2.408 -3.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    className: "cls-2",
    d: "M26.423,24H19.437a.437.437,0,1,0,0,.873h6.986a.437.437,0,1,0,0-.873Z",
    transform: "translate(-2.408 -3.042)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    className: "cls-2",
    d: "M26.423,21H19.437a.437.437,0,1,0,0,.873h6.986a.437.437,0,1,0,0-.873Z",
    transform: "translate(-2.408 -2.662)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    className: "cls-2",
    d: "M25.029,15H8.437a.437.437,0,0,0,0,.873H25.029a.437.437,0,0,0,0-.873Z",
    transform: "translate(-1.014 -1.901)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    className: "cls-2",
    d: "M25.029,18H8.437a.437.437,0,1,0,0,.873H25.029a.437.437,0,0,0,0-.873Z",
    transform: "translate(-1.014 -2.282)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    className: "cls-2",
    d: "M8.873,11.86h6.113a.872.872,0,0,0,.873-.873V4.877A.872.872,0,0,0,14.986,4H8.873A.872.872,0,0,0,8,4.877v6.109A.873.873,0,0,0,8.873,11.86Zm.873-6.113h4.366v4.366H9.747Z",
    transform: "translate(-1.014 -0.507)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/Reports.e4785143.svg";
export { ForwardRef as ReactComponent };